import _styled, { default as _styled2 } from "styled-components";
import React from "react";
import { createPortal } from "react-dom";
type Props = {
  /** The element that triggers the tooltip on hover. */
  children: React.ReactNode;
  /** The tooltip content. */
  content: React.ReactNode;
};

/**
 * Cursor-following tooltip: its top-left corner sits at the pointer and it opens
 * downward (under the mouse). Squared, with a left-side accent border.
 */
export function HoverTooltip(props: Props) {
  const {
    children,
    content
  } = props;
  const [pos, setPos] = React.useState<{
    x: number;
    y: number;
  } | null>(null);
  const [mounted, setMounted] = React.useState(false);
  React.useEffect(() => setMounted(true), []);
  const track = (e: React.MouseEvent) => setPos({
    x: e.clientX,
    y: e.clientY
  });
  const hide = () => setPos(null);
  return <>
      <_StyledSpan onMouseEnter={track} onMouseMove={track} onMouseLeave={hide}>
        {children}
      </_StyledSpan>
      {mounted && pos && createPortal(<_StyledDiv style={{
      left: pos.x,
      top: pos.y
    }} $_css={[{
      "pointerEvents": "none",
      "position": "fixed",
      "zIndex": "200",
      "--tw-bg-opacity": "1",
      "backgroundColor": "rgb(255 255 255 / var(--tw-bg-opacity))",
      "--tw-text-opacity": "1",
      "color": "rgb(0 7 4 / var(--tw-text-opacity))",
      "--tw-shadow": "0 1px 3px 0 rgb(0 0 0 / 0.1), 0 1px 2px -1px rgb(0 0 0 / 0.1)",
      "--tw-shadow-colored": "0 1px 3px 0 var(--tw-shadow-color), 0 1px 2px -1px var(--tw-shadow-color)",
      "boxShadow": "var(--tw-ring-offset-shadow, 0 0 #0000), var(--tw-ring-shadow, 0 0 #0000), var(--tw-shadow)"
    }, {
      "maxWidth": "262px",
      "userSelect": "none",
      "borderLeftWidth": "2px",
      "--tw-border-opacity": "1",
      "borderColor": "rgb(75 46 248 / var(--tw-border-opacity))",
      "paddingLeft": "1.2rem",
      "paddingRight": "1.2rem",
      "paddingTop": "0.8rem",
      "paddingBottom": "0.8rem",
      "fontSize": "1.4rem",
      "lineHeight": "1.5",
      "letterSpacing": "0.014000000000000002rem",
      "fontWeight": "400"
    }]}>
            {content}
          </_StyledDiv>, document.body)}
    </>;
}
var _StyledSpan = _styled("span").withConfig({
  componentId: "sc-sf-44bql8-0"
})({
  "display": "flex",
  "height": "100%",
  "width": "100%"
});
var _StyledDiv = /*#__PURE__*/_styled2("div").withConfig({
  displayName: "hover-tooltip___StyledDiv",
  componentId: "sc-18dqavi-0"
})(["", ""], p => p.$_css);